import { useWindowDimensions } from '../../../providers/WindowDimensionsProvider'
import { RESPONSIVE_BREAKPOINTS } from '../../../utils/constants'

const ResponsiveLayout = ({ renderXSmall = null, renderSmall = null, renderMedium = null, renderLarge = null }) => {
  const { width } = useWindowDimensions() || window.innerWidth
  const { xSmall, small, large } = RESPONSIVE_BREAKPOINTS

  if (width <= xSmall && renderXSmall) {
    return renderXSmall()
  } else if (width < small && renderSmall) {
    return renderSmall()
  } else if (width <= large && renderMedium) {
    return renderMedium()
  }
  return renderLarge && renderLarge()
}

export default ResponsiveLayout